"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItem = void 0;
var item_1 = require("./item");
Object.defineProperty(exports, "NavItem", { enumerable: true, get: function () { return __importDefault(item_1).default; } });
